import script from "./multi-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-select.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__